export class JobsTrackers {
  /**
   * Job Stats
   * */
  static readonly JOB_TRACKER_JOB_STATS_NAVIGATE_TO_JOB_LIST_CLICK =
    '[Jobs] job stats navigate to jobs list CTA click';

  static readonly JOB_TRACKER_JOB_STATS_REFRESH_CLICK = '[Jobs] job stats refresh click';

  static readonly JOB_TRACKER_JOB_STATS_CANCEL_CLICK = '[Jobs] job stats cancel click';

  /**
   * Job Objects List
   * */
  static readonly JOB_TRACKER_JOB_OBJECTS_LIST_JOBS_TABLE_TOGGLE =
    '[Jobs] job objects list table toggle';

  static readonly JOB_TRACKER_JOB_OBJECT_STAGE_FAILURE_DETAILS_DOWNLOAD_CLICK =
    '[Jobs] job object stage failure details download click';

  static readonly JOB_TRACKER_JOB_OBJECT_STAGE_FAILURE_DETAILS_DOWNLOAD_CANCEL_CLICK =
    '[Jobs] job object stage failure details download cancel click';

  static readonly JOB_TRACKER_JOB_MODE_ID_COPY_CLICK = '[Jobs] job mode id copy click';

  /**
   * Jobs View
   * */
  static readonly JOB_TRACKER_JOBS_INTRO_CREATE_PIPELINE_CLICK =
    '[Jobs] job intro create pipeline click';

  static readonly JOB_TRACKER_JOBS_TABLE_JOB_WITH_PIPELINE_DETAILS_CLICK =
    '[Jobs] jobs table job with pipeline details click';

  static readonly JOB_TRACKER_JOBS_TABLE_JOB_CLICK = '[Jobs] jobs table job click';

  static readonly JOB_TRACKER_DOWNLOAD_JOB_SESSION_LOG_CLICK =
    '[Job Details] download session log click';

  static readonly JOB_TRACKER_DOWNLOAD_JOB_SESSION_LOG_RETRY_CLICK =
    '[Job Details] download session log retry click';

  static readonly JOB_TRACKER_DOWNLOAD_JOB_SESSION_LOG_SUCCESS =
    '[Job Details] download session log success';

  static readonly JOB_TRACKER_DOWNLOAD_JOB_SESSION_LOG_ERROR =
    '[Job Details] download session log error';
}
